import { ArrowUp } from "lucide-react";
import { PROFILE } from "@/data/content";

const Footer = ({ onNavigate }) => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="border-t border-line bg-ink">
      <div className="mx-auto max-w-[1600px] px-6 py-16 md:px-12 md:py-20">
        <div className="flex flex-col items-start justify-between gap-10 border-b border-line pb-12 md:flex-row md:items-end">
          <div>
            <h2 className="font-display text-5xl font-semibold uppercase leading-[0.9] tracking-tightest text-chalk md:text-7xl">
              {PROFILE.name}
              <span className="text-signal">°</span>
            </h2>
            <p className="mt-4 max-w-sm text-[13px] leading-[1.6] text-ash">
              {PROFILE.studio} — my independent design &amp; digital-solutions practice.
            </p>
          </div>
          <button
            data-testid="footer-back-to-top"
            onClick={() => onNavigate?.("#top")}
            className="group inline-flex min-h-[48px] items-center gap-3 font-mono text-[13px] uppercase tracking-[0.2em] text-chalk transition-colors hover:text-signal"
          >
            Back to top
            <span className="flex h-10 w-10 items-center justify-center rounded-full border border-line transition-colors group-hover:border-signal">
              <ArrowUp className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5" />
            </span>
          </button>
        </div>

        <div className="mt-8 flex flex-col justify-between gap-4 md:flex-row">
          <p className="font-mono text-[12px] uppercase tracking-[0.14em] text-chalk/70">
            © {year} {PROFILE.name} — All rights reserved
          </p>
          <p className="font-mono text-[12px] uppercase tracking-[0.14em] text-chalk/70">{PROFILE.location}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
